import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../Redux/apiSlice";

const PAGE_LIST_URL = `${API_URL}/pages`;
const PAGE_DELETE_URL = `${API_URL}/pages`;

const PageList = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAuthHeader = () => {
    try {
      const raw = localStorage.getItem("knighthuntToken") || "";
      const token = raw.trim();
      if (!token) return null;
      return token.toLowerCase().startsWith("bearer ")
        ? token
        : `Bearer ${token}`;
    } catch {
      return null;
    }
  };

  // Fetch pages
  const fetchPages = async () => {
    try {
      setLoading(true);

      const auth = getAuthHeader();

      const resp = await fetch(PAGE_LIST_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(auth ? { Authorization: auth } : {}),
        },
        credentials: "include",
      });

      const data = await resp.json();
      const list = data?.data || data?.response || [];

      setPages(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Fetch pages error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("Pages", pages);
    
  }, [pages]);
  // Soft delete (disable page)
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to disable this page?")) return;

    try {
      const auth = getAuthHeader();

      const resp = await fetch(`${PAGE_DELETE_URL}/${id}`, {
        method: "DELETE",
        headers: {
          ...(auth ? { Authorization: auth } : {}),
        },
        credentials: "include",
      });

      const data = await resp.json();

      if (data?.status) {
        alert("Page disabled successfully!");
        fetchPages();
      } else {
        alert(data?.message || "Failed to disable page.");
      }
    } catch (err) {
      console.error("Delete page error:", err);
      alert("Error while disabling page (check console).");
    }
  };

  useEffect(() => {
    fetchPages();
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="page-content">
      <h3>Pages</h3>

      <Link to="/page-create" className="btn btn-primary mb-3">
        Add Page
      </Link>

      <table className="table align-middle">
        <thead>
          <tr>
            <th>Title</th>
            <th>Slug</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {pages.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center text-muted">
                No pages found
              </td>
            </tr>
          ) : (
            pages.map((page) => (
              <tr key={page.id}>
                <td style={{ fontWeight: "600" }}>{page.title}</td>

                <td>{page.slug}</td>

                <td>
                  {page.isActive ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </td>

                <td>
                  <Link
                    to={`/page-edit/${page.id}`}
                    className="btn btn-sm btn-warning me-2"
                  >
                    Edit
                  </Link>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(page.id)}
                  >
                    Disable
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PageList;
